/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stale_Basic_Bird_KickInputs */

const fr_stale_basic_bird_kick = /** @type {(inputs: Stale_Basic_Bird_KickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historique des meilleurs performances par exercice`)
};

/**

* @param {Stale_Basic_Bird_KickInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const stale_basic_bird_kick = /** @type {((inputs?: Stale_Basic_Bird_KickInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stale_Basic_Bird_KickInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_stale_basic_bird_kick(inputs)
});